import { render, staticRenderFns } from "./rDynamicList.vue?vue&type=template&id=ff8f3c16&scoped=true&"
import script from "./rDynamicList.vue?vue&type=script&lang=js&"
export * from "./rDynamicList.vue?vue&type=script&lang=js&"
import style0 from "./rDynamicList.vue?vue&type=style&index=0&id=ff8f3c16&prod&scoped=true&lang=css&"
import style1 from "./rDynamicList.vue?vue&type=style&index=1&id=ff8f3c16&prod&lang=css&"
import style2 from "./rDynamicList.vue?vue&type=style&index=2&id=ff8f3c16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f3c16",
  null
  
)

export default component.exports